import clsx from "clsx";

import "./dark.layout.scss";

export const DarkLayout = ({ children, className }) => {
  return (
    <div className={clsx("dark-layout", className)}>
      <div className="shapes-container top">
        <img
          className="spiral-image"
          src="/images/shapes/spiral.png"
          alt="torus"
        />
        <img
          className="sphere-image"
          src="/images/shapes/sphere.png"
          alt="sphere"
        />
        <img className="cube-image" src="/images/shapes/cube.png" alt="cube" />
      </div>
      {children}
      <div className="shapes-container bottom">
        <img
          className="torus-image"
          src="/images/shapes/torus.png"
          alt="torus"
        />
        <img className="cube-image" src="/images/shapes/cube.png" alt="cube" />
      </div>
    </div>
  );
};
